import React from 'react';

/**
 * Pulsing green dot + label shown when a work order timer is currently
 * running (i.e. at least one time entry has `isActive=true`). Mirrors the
 * "In progress" indicator on the schedule JobCard.
 *
 * The indicator hides automatically once the work order is closed out
 * because the backend stops active timers when status moves to COMPLETED,
 * which flips `hasActiveTimer` to false.
 */
const WorkOrderActiveTimerIndicator = ({ hasActiveTimer, label = 'In Progress', className = '' }) => {
  if (!hasActiveTimer) return null;

  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative mr-2">
        <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
        <div className="absolute top-0 left-0 w-2 h-2 bg-emerald-500 rounded-full animate-ping"></div>
      </div>
      <span className="text-xs text-emerald-600 font-medium">{label}</span>
    </div>
  );
};

export default WorkOrderActiveTimerIndicator;
